import { render, staticRenderFns } from "./xiangqing.vue?vue&type=template&id=19b0b1d8"
import script from "./xiangqing.vue?vue&type=script&lang=js"
export * from "./xiangqing.vue?vue&type=script&lang=js"
import style0 from "./xiangqing.vue?vue&type=style&index=0&id=19b0b1d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports